export default "__VITE_ASSET__BeaJ_k30__"